// extracted by mini-css-extract-plugin
export default {"container":"LoadingPan_container__0sebZ"};